import api from '../../api/index';

const set_percent_additional = (item, field) => {
  let result = item[field];
  let percent_field = `${field}_percent`;

  if (item.hasOwnProperty(percent_field)) {
    result = `${result} (${item[percent_field]}%)`;
  }

  return result;
};

export default {
  namespaced: true,
  state     : {
    employee_study_users: {
      content: {
        search    : '',
        pagination: {
          rowsPerPage: 10,
        },
        headers: [
          {text: 'ФИО, должность', value: 'name', sort: true},
          {text: 'Организация', value: 'company_name', sort: true},
          {text: 'Страна', value: 'country_name', sort: true},
          {text: 'Кол-во курсов', value: 'all_course_count', sort: true},
          {text: 'Статус "Новый"', value: 'new_course_count', sort: true},
          {
            text       : 'Статус "Идет обучение"',
            value      : 'status',
            inner_items: [
              {
                text : 'Не просрочен',
                value: 'not_expired_course_history_count',
                sort : true,
              },
              {
                text : 'Просрочен',
                value: 'expired_course_history_count',
                sort : true,
              },
            ],
          },
          {text: 'Статус "Завершен"', value: 'completed_course_count', sort: true},
          {text: 'Рейтинг', value: 'rating_users_points', sort: true},
          {text: 'Ср. балл', value: 'average_users_points', sort: true},
        ],
        body: [],
      },
    },
    showed_users_filter: false,
    example_user       : {
      id        : 20,
      name      : 'Кекс',
      family    : 'Тортов',
      patronymic: 'Кексович',
      avatar    : '/images/employee_avatar.png',
      position  : [
        {status: 'division', name: 'Директор по маркетингу', icon: 'job'},
        {status: 'subdivision', name: 'Продуктовый маркетинг', icon: 'subdivision'},
        {status: 'role', name: 'Ответственное лицо организации', icon: 'role'},
      ],
      organization: {
        id    : 22,
        image : '/images/lukoil-round.png',
        name  : 'Лукойл-Москва',
        rating: 1232,
      },
      directorate: {
        id: 50,
      },
      courses_stat: {
        org_rating: {
          stat: 21,
        },
        total_rating: {
          stat: 112,
        },
      },
    },
  },
  getters: {
    example_user                 : ({example_user}) => example_user,
    showed_users_filter          : ({showed_users_filter}) => showed_users_filter,
    employee_study_users         : ({employee_study_users}) => employee_study_users,
    employee_study_users_filtered: ({employee_study_users}, getters, rootState) => {
      const search = rootState.employee_study.search;
      let answer = employee_study_users;

      answer.content.body = answer.content.body.filter((value) => {
        return value.name.toLowerCase().includes(search.toLowerCase());
      });

      return answer;
    },
    get_user_by_id: ({employee_study_users}, {}, {route}, rootGetter) => {
      let current_id = route.query.user;
      return employee_study_users.content.body.find((item)=>item.id === current_id);
    },
  },
  mutations: {
    // CLOSE_MODAL(state, type) {
    //   let modal = state.modals.find((modal)=> modal.type === type);
    //   modal.active = false;
    // },
    // OPEN_MODAL(state, type) {
    //   let modal = state.modals.find((modal)=> modal.type === type);
    //   if (!modal.active) {
    //     modal.active = true;
    //   }
    // },
    TOGGLE_USERS_FILTER(state) {
      state.showed_users_filter = !state.showed_users_filter;
    },
    SHOW_USERS_NUMBER(state, selected) {
      const table = state.employee_study_users.content;
      table.pagination.rowsPerPage = selected;
    },
    SET_USERS_PAGINATION(state, value) {
      let table = state.employee_study_users.content;
      table.pagination = value;
    },

    SET_USERS_PAGE(state, value) {
      let table = state.employee_study_users.content;
      table.pagination.page = value;
    },
    CHANGE_USERS_SORT(state, column) {
      let table = state.employee_study_users.content;
      if (table.pagination.sortBy === column) {
        table.pagination.descending = !table.pagination.descending;
      } else {
        table.pagination.sortBy = column;
        table.pagination.descending = false;
      }
    },
    SEARCH_USERS(state, value) {
      state.employee_study_users.content.search = value;
    },
    SET_USERS(state, value) {
      state.employee_study_users.content.body = value.map((user) => ({
        ...user,
        new_course_count      : set_percent_additional(user, 'new_course_count'),
        completed_course_count: set_percent_additional(user, 'completed_course_count'),
        status                : {
          not_expired_course_history_count: set_percent_additional(user, 'not_expired_course_history_count'),
          expired_course_history_count    : set_percent_additional(user, 'expired_course_history_count'),
        },
      }));
    },

    SET_PAGINATION(state, value) {
      state.employee_study_users.content.pagination = {...state.employee_study_users.content.pagination, ...value};
    },
  },
  actions: {
    async get_users({commit}) {
      try {
        const users = await api.learning.get_users();
        commit('SET_USERS', users.data.data);
      } catch (err) {
        console.error(err);
      }
    },
    async change_user_per_page({commit}, event) {
      commit('SHOW_USERS_NUMBER', event);
      commit('SET_USERS_PAGE', 1);
    },
  },
};
